/**
 * Summary
 * --
 */
import React, { useState } from 'react';
import { Content, Statistic } from 'components';
import { stringToMoneyFormat } from 'utils';

/**----------------------------------------
 * [Component] 필터
 * ----------------------------------------
 */
const Summary = ({
  totalCount,
  totalAmount,
  totalPrice,
  totalCharge,
  totalRefundPrice,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content
        fullWidth
        padding={0}
        backgroundColor={'none'}
        style={{
          marginBottom: 4,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {[
          {
            title: '가입자',
            value: stringToMoneyFormat(totalCount),
            suffix: '건',
          },
          {
            title: '잔액합계',
            value: stringToMoneyFormat(totalAmount),
            suffix: '원',
          },
          {
            title: '결제금액',
            value: stringToMoneyFormat(totalPrice),
            suffix: '원',
          },
          {
            title: '충전금액',
            value: stringToMoneyFormat(totalCharge),
            suffix: '건',
          },
          {
            title: '취소/환불금액',
            value: stringToMoneyFormat(totalRefundPrice),
            suffix: '원',
          },
        ].map((_item, _index) => (
          <div
            key={`${_item.label}-${_index}`}
            className="boxShadow"
            style={{
              background: '#FFFFFF',
              borderRadius: 4,
              width: `90%`,
              // width: `calc(100% / 3)`,
              // marginRight: _index === 7 ? 0 : 4,
              margin: '0 2px',
              padding: '24px 15px',
            }}
          >
            <Statistic
              title={_item.title}
              value={_item.value}
              suffix={_item.suffix}
              direction={'row'}
              style={{ justifyContent: 'center' }}
            />
          </div>
        ))}
      </Content>
    </>
  );
};

/* DF */
Summary.defaultProps = {
  totalCount: 0,
  totalAmount: 0,
  totalPrice: 0,
  totalCharge: 0,
  totalRefundPrice: 0,
};
export default Summary;
